import { Grid } from '@/common/grid/Grid';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useEffect, useRef, useState } from 'react';

// TODO: When count is loading, then '-'
export const PerspectiveTrxLookupViewerGrid = ({
  viewerReqParam,
  entity,
  onOppositeSide,
  side,
  onExportReqChange,
}) => {

  const rsrc = useRsrc();
  const module = useModuleFromRoute();

  const gridRef = useRef();

  const [fieldDefs, setFieldDefs] = useState();

  useEffect(() => {
    rsrc.viewerFieldDefs(module, 'PERSPECTIVE_TRX_LOOKUP_VIEWER_PLUGIN', viewerReqParam, entity).then(fieldDefs => {
      setFieldDefs(fieldDefs);
    })
  }, [])

  useEffect(() => {
    if (!gridRef.current) return;
    onGridReady();
  }, [onOppositeSide]);

  const onGridReady = (params) => {
    const dataSource = {
      getRows: (params) => {

        const expr = ExprUtils.filterModelToExpr(params.filterModel, fieldDefs);

        const reqParam = { 
          ...viewerReqParam,
          startRow: params.startRow,
          endRow: params.endRow,
          onOppositeSide,
          expr
        };

        if (onExportReqChange) {
          const sideUpdate =
            side === 'left'
              ? { leftViewerReqParam: reqParam, leftFieldDefs: fieldDefs }
              : { rightViewerReqParam: reqParam, rightFieldDefs: fieldDefs };
          onExportReqChange(sideUpdate);
        }

        rsrc.viewerRows(module, 'PERSPECTIVE_TRX_LOOKUP_VIEWER_PLUGIN', reqParam, entity).then(res => {
          if (gridRef.current) {
            gridRef.current.onGridSuccess(res, params);
            gridRef.current.resize();
          }
        })

        rsrc.viewerCount(module, 'PERSPECTIVE_TRX_LOOKUP_VIEWER_PLUGIN', reqParam, entity).then(count => {
          if (gridRef.current) {
            gridRef.current.setCount(count);
          }

        })

        rsrc.viewerAggTotals(module, 'PERSPECTIVE_TRX_LOOKUP_VIEWER_PLUGIN', reqParam, entity).then(aggTotals => {
          if (gridRef.current) {
            gridRef.current.setTotalsRow(aggTotals);
          }
        })
      }
    }

    gridRef.current.setDataSource(dataSource);
  }

  return (
    fieldDefs &&
      <Grid
        ref={gridRef}
        gridOptions={{ fieldDefs }}
        events={{ onGridReady }}
      />
  );
}